<template>
    <div :id="'itemHistorical_' + data.id" class="register-tasks-card">
        <div class="data-date">
            <ul class="historical-register">
                <li class="historical-register-li">
                    <span v-if="showDate" class="date-text">{{ historicalDateCreate(data?.created_at) }}</span>

                    <!-- <div v-if="index == 0 && loadNewCard" class="loading-card">
                        <ui-load-indicator :h="50" :stroke="8" bg-color="#e7e9f4" color="#69D296" />
                    </div> -->

                    <!-- <div class="historical-item" :class="{'new-card': index == 0 && loadNewCard}"> -->
                    <div class="historical-item">
                        <div v-if="isEdit" class="check-radius">
                            <label class="checkbox-label" aria-label="Toggle task completion" :class="{ 'tasks-checkbox-inactive': !isEditCheckBox}" :for="`task-${data.id}`">
                                <input
                                    :id="`task-${data.id}`"
                                    v-model="isEditCheckBox"
                                    type="checkbox"
                                    class="task-checkbox"
                                    @click="updateStatusCard($event, data.id)"
                                />
                                <em class="fas fa-check checkbox-active" :class="{ 'checkbox-inactive': !isEditCheckBox }" />
                            </label>
                        </div>

                        <div v-else class="item-img">
                            <ui-image :src="getImgCDN(dataCover)" alt="Avatar" design="circle" h="35" w="35" />
                        </div>

                        <div class="item-content">
                            <div class="icon-type">
                                <em :class="typeIcon(data.type)" />
                            </div>

                            <div class="user-name-profile">
                                <span class="user-name-text">{{ dataFirstName }}<span v-if="data?.user?.group" class="profile"> - {{ switchGroup(data.user.group[0]) }}</span></span>
                            </div>

                            <div v-if="isEdit" class="menu-card-edit">
                                <ui-menu-card>
                                    <button
                                        v-for="(menu, index) in menuOptions"
                                        :key="`${index}-${menu.label}`"
                                        type="button"
                                        :disabled="menu.label === 'Excluir' && isButtonDisabled"
                                        @click="handleMenuClick(menu, data.id)"
                                    >
                                        {{ menu.label }}

                                        <div v-if="menu.label.trim() == 'Excluir' && loadingDeleteButton" class="loading-card-button">
                                            <ui-load-indicator :h="16" :stroke="12" bg-color="#e7e9f4" color="#69D296" />
                                        </div>
                                    </button>
                                </ui-menu-card>
                            </div>

                            <div v-if="data?.subject" class="create-tasks-text">
                                <span class="text">{{ data?.subject }}</span>
                            </div>

                            <div v-if="data?.title" class="tasks-text">
                                <span class="text">Tarefa: </span>
                                <span class="text-content">{{ data?.title }}</span>
                            </div>

                            <div v-if="data?.message" class="description-text">
                                <span v-html="formateMessage(data?.message)" />
                            </div>

                            <!-- <div v-if="isHtml(data?.message)" class="is-html">
                                <div class="is-html-content" v-for="(item, index) in parsedHtmlContent" :key="index">
                                    <span v-if="!hasLineBreaks(item.content)" class="is-html-strong">{{ item.label }}:</span> <span v-if="!hasLineBreaks(item.content)">{{ item.content }}</span><br v-if="!hasLineBreaks(item.content)" />

                                    <span v-if="hasLineBreaks(item.content)" class="is-html-strong">{{ item.label }}: </span>
                                    <div v-if="hasLineBreaks(item.content)" v-for="(line, index) in splitMessageLines(item.content)" :key="index">
                                        {{ line }}
                                    </div>
                                </div>
                            </div>

                            <ul v-if="dynamicHtmlContent.length > 0 && parsedHtmlContent.length == 0" class="description-text-list">
                                <li v-for="(item, index) in formatMessage(dynamicHtmlContent)" :key="index">
                                    {{ item }}
                                </li>
                            </ul>

                            <div v-if="!isHtml(data?.message) && !data?.title" class="description-text">
                                <div v-for="(line, index) in splitMessageLines(data?.message)" :key="index">
                                    {{ line }}
                                </div>
                            </div> -->

                            <div v-if="data?.notes" class="notes-text">
                                <span class="notes">Nota: </span>
                                <span v-html="formateMessage(data?.notes)" />

                                <!-- <div class="notes-content" v-for="(line, index) in splitMessageLines(data?.notes)" :key="index">
                                    {{ line }}
                                </div> -->
                            </div>

                            <div v-if="data?.for_date" class="notes-text">
                                <span class="notes">Data de Vencimento: </span>

                                <span class="notes-content">{{ formattedDateAndTime }}</span>
                            </div>

                            <div class="date-footer">
                                <div class="data-footer">
                                    <span class="date">Data: </span>
                                    <span class="date-content">{{ data?.created_at | moment("DD/MM/YYYY [às] HH:mm") }}</span>
                                </div>

                                <div v-if="showMenuCard || isEdit" class="fac-menu-links">
                                    <div v-if="isEdit" class="item-menu-img">
                                        <ui-image :src="getImgCDN(dataCover)" alt="Avatar" design="circle" h="20" w="20" />
                                    </div>

                                    <ui-menu-card v-else>
                                        <button
                                            v-for="(menu, index) in menuOptions"
                                            :key="`${index}-${menu.label}`"
                                            type="button"
                                            @click="handleMenuClick(menu, data.id)"
                                        >
                                            {{ menu.label }}

                                            <div v-if="menu.label.trim() == 'Excluir' && loadingDeleteButton" class="loading-card-button">
                                                <ui-load-indicator :h="16" :stroke="12" bg-color="#e7e9f4" color="#69D296" />
                                            </div>
                                        </button>
                                    </ui-menu-card>
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import { uiImage, uiLoadIndicator, uiMenuCard } from '@/components/ui'
import { helpersMixin } from '@/mixins'
import { mapGetters } from 'vuex'

    const moment = require('moment')
    require('moment/locale/pt-br')

    const defaultMenuOptions = () => [
        {
            active: true,
            label: 'Editar'
        },
        {
            active: true,
            label: 'Excluir'
        }
    ]

    export default {
        name: 'register-tasks-card',

        components: {
            uiImage,
            uiMenuCard,
            uiLoadIndicator
        },

        mixins: [helpersMixin],

        props: {
            data: {
                type: Object,
                default: () => {}
            },
            showDate: {
                type: Boolean,
                default: false
            },
            menuOptions: {
                type: Array,
                default: () => defaultMenuOptions()
            },
            disableAfterMinutes: {
                type: Number,
                default: 15
            },
            disableFlag: {
                type: Boolean,
                default: false
            },
            index: {
                type: Number,
                default: null
            },
            loadNewCard: {
                type: Boolean,
                default: false
            },
            isEdit: {
                type: Boolean,
                default: false
            }
        },

        data() {
            return {
                isEditCheckBox: false,
                loadingDeleteButton: false
            }
        },

        computed: {
            ...mapGetters('auth', {
                user: 'getUser',

            }),

            dataCover() {
                if(this.data?.user) {
                    return this.data?.user?.cover
                } else if (this.data?.users?.user) {
                    return this.data?.users?.user?.cover
                } else return false
            },

            dataFirstName() {
                if (this.data?.user) {
                    return this.data?.user?.first_name
                } else if (this.data?.users?.user) {
                    return this.data?.users?.user?.first_name
                } else return false
            },

            isButtonDisabled() {
                if (!this.disableFlag) return false
                const createdTime = moment(this.data.created_at)
                const currentTime = moment()
                const minutesDiff = currentTime.diff(createdTime, 'minutes')
                return minutesDiff >= this.disableAfterMinutes
            },

            showMenuCard() {
                const createdTime = moment(this.data.created_at)
                const currentTime = moment()
                const minutesDiff = currentTime.diff(createdTime, 'minutes')
                return minutesDiff < this.disableAfterMinutes &&
                    this.data.type != 'task' &&
                    this.data.type != 'system'
            },

            formattedDateAndTime() {
                const date = this.data?.for_date
                const time = this.data?.for_hour
                return `${moment(date).format('DD/MM/YYYY')} às ${time}`
            },

            parsedHtmlContent() {
                if (!this.isHtml(this.data?.message)) {
                    return []
                }

                const div = document.createElement('div')
                div.innerHTML = this.data?.message.replace(/\\\//g, '/') // Converte os <\/b> para </b>
                const items = []

                div.querySelectorAll('b').forEach(b => {
                    const label = b.textContent.trim().replace(':', '')
                    const content = b.nextSibling.textContent.trim()

                    items.push({ label, content })
                })

                return items
            },

            dynamicHtmlContent() {
                if (!this.isHtml(this.data?.message)) {
                    return []
                }

                const dynamicData = this.extractDynamicData(this.data?.message)

                return dynamicData
            }
        },

        beforeDestroy() {
            this.loadingDeleteButton = false
        },

        methods: {
            hasLineBreaks(text) {
                return text.includes('\n');
            },

            splitMessageLines(message) {
                if (!message) return [];
                return message.split('\n'); // Divide o texto onde houver '\n'
            },

            removeHtmlTags(content) {
                // Cria um parser para converter a string em um documento DOM
                const parser = new DOMParser()
                const parsedHtml = parser.parseFromString(content, 'text/html')

                // Retorna o texto sem as tags HTML
                return parsedHtml.body.textContent || ""
            },

            formatMessage(messageArray) {
                // Junta o array em uma string única e remove colchetes e aspas
                let formattedMessage = messageArray.join(', ').replace(/[\]"]/g, '')
                let message = this.removeHtmlTags(formattedMessage)

                // Substitui as vírgulas por quebras de linha
                formattedMessage = message.replace(/, /g, '<br>')

                return formattedMessage.split('<br>')
            },

            extractDynamicData(message) {
                const data = []

                // Divide a string em linhas usando <br> ou \n como delimitador
                const lines = message.split(/<br\/?>|\n/)

                lines.forEach(line => {
                    // Remove o hífen inicial, se existir, e remove espaços extras
                    line = line.trim().replace(/^-/, '').trim()

                    // Encontra a posição do primeiro ':' que marca o início do novo valor
                    const separatorIndex = line.indexOf(':')

                    if (separatorIndex !== -1) {
                        // Pega o label (as palavras antes dos dois pontos)
                        const label = line.slice(0, separatorIndex).trim()

                        // Pega o valor após os dois pontos e o ajusta (se houver)
                        const newValue = line.slice(separatorIndex + 1).trim()

                        // Adiciona o valor formatado ao array
                        data.push(`-${label}: ${newValue}`)
                    }
                })

                return data
            },

            isHtml(str) {
                const div = document.createElement('div')
                div.innerHTML = str
                return div.children.length > 0
            },

            handleMenuClick(menu, id) {
                if (menu.label === 'Excluir') {
                    this.deleteCard(id)
                } else if (menu.label === 'Editar') {
                    this.editCard(id)
                }
            },

            deleteCard(id) {
                this.$emit('delete-card', id)
                this.loadingDeleteButton = true
            },

            editCard(id) {
                this.$emit('edit-card', id)
            },

            updateStatusCard(event, id) {
                this.isEditCheckBox = event.target.checked

                this.$emit('update-card', id, this.isEditCheckBox)
            },

            historicalDateCreate(value) {
                let result
                result = moment(value).format('MMMM YYYY')
                return `${result[0].toUpperCase() + result.slice(1)}`
            },

            switchGroup(group) {
                switch (group.name) {
                    case 'system':
                        return 'Sistema'
                    case 'admin':
                        return `Administrador`
                    case 'manager':
                        return `Gerente`
                    case 'supervisor':
                        return `Supervisor`
                    case 'broker':
                        return `Vendedor`
                    case 'collaborator':
                        return `Colaborador`
                    default:
                        return group.name
                }
            },

            typeIcon(type) {
                switch (type) {
                    case 'chat':
                        return 'fas fa-comments-alt'
                    case 'mail':
                        return 'fas fa-envelope-open'
                    case 'call':
                        return 'fas fa-phone-alt'
                    case 'observation':
                        return 'fas fa-tag'
                    case 'visit':
                        return 'fal fa-user-friends'
                    case 'whatsapp':
                        return 'fab fa-whatsapp'
                    default:
                        return 'fal fa-cog'
                }
            },

            formateMessage(msg) {
                return msg.replace(/\n/g, '<br>')
            }
        },
    }
</script>

<style lang="stylus" scoped>
    @import 'styles.styl'
</style>
